var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9199 17.6238V20.7488C22.9211 21.0389 22.8617 21.3261 22.7454 21.5919C22.6292 21.8577 22.4588 22.0963 22.245 22.2924C22.0312 22.4885 21.7788 22.6378 21.504 22.7308C21.2292 22.8237 20.938 22.8582 20.6491 22.8321C17.4437 22.4838 14.3647 21.3885 11.6595 19.6342C9.14265 18.0349 7.00881 15.9011 5.4095 13.3842C3.64906 10.6667 2.5535 7.57275 2.21158 4.35297C2.18555 4.06491 2.21978 3.77459 2.3121 3.50049C2.40442 3.22639 2.5528 2.97452 2.74779 2.7609C2.94279 2.54729 3.18013 2.37662 3.4447 2.25976C3.70926 2.1429 3.99527 2.0824 4.2845 2.08213H7.4095C7.91502 2.07716 8.40511 2.25617 8.78841 2.58581C9.17172 2.91545 9.42208 3.37322 9.49283 3.8738C9.62473 4.87387 9.86934 5.85581 10.222 6.80088C10.3621 7.17372 10.3925 7.57892 10.3094 7.96847C10.2263 8.35801 10.0333 8.71558 9.75325 8.9988L8.43033 10.3217C9.9132 12.9296 12.0725 15.0888 14.6803 16.5717L16.0032 15.2488C16.2865 14.9687 16.644 14.7757 17.0336 14.6926C17.4231 14.6096 17.8283 14.6399 18.2012 14.78C19.1462 15.1327 20.1282 15.3773 21.1282 15.5092C21.6343 15.5806 22.0964 15.8355 22.4267 16.2254C22.7571 16.6152 22.9326 17.1129 22.9199 17.6238Z",
    fill: "#DCA11C",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.16b702cd8693cc332db1265181f4fe63.svg";
export { ForwardRef as ReactComponent };